import {ShoppingBag} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {ColumnDef, DataTable} from "../../../shared/tables/DataTable.tsx";
import {VwpProduct} from "../../../../store/generated/api.ts";

interface ProductTableProps {
    products: VwpProduct[];
    onProductClick: (product: VwpProduct) => void;
}

export function ProductTable({products, onProductClick}: ProductTableProps) {
    const {t} = useTranslationWithKeys();

    const columns: ColumnDef<VwpProduct>[] = [
        {
            key: "name",
            header: t('admin.products.tableHeaders.name'),
            cell: (product) => (
                <div className="flex items-center gap-2">
                    <ShoppingBag className="h-4 w-4 text-muted-foreground"/>
                    {product.name}
                </div>
            )
        },
        {
            key: "description",
            header: t('admin.products.tableHeaders.description')
        },
        {
            key: "stripeProductId",
            header: t('admin.products.tableHeaders.stripeId'),
            className: "text-muted-foreground"
        },
        {
            key: "totalLicenses",
            header: t('admin.products.tableHeaders.totalLicenses')
        },
        {
            key: "activeSubscriptions",
            header: t('admin.products.tableHeaders.activeSubscriptions')
        }
    ];

    return (
        <DataTable
            data={products}
            columns={columns}
            onRowClick={onProductClick}
            withBorder={false}
        />
    );
}